var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.config[_vm.icon] ? _vm.config[_vm.icon].icon: null,{tag:"component",style:(_vm.iconStyle),attrs:{"size":_vm.size,"title":null},on:{"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }